import { MultiSelect } from "react-multi-select-component";
import styles from "./FilterForm.module.scss";
import classnames from "classnames";
import { useEffect, useRef, useState } from "react";
import { Clock } from "components/assets/Icons";



const FilterForm = ({
  isLoggedIn,
  handleOnSubmit,
  scheduleOptions,
  params,
  formError,
}) => {
  const ref = useRef();
  const [open, setOpen] = useState(true);
  const [selected, setSelected] = useState([]);

  const schedulesValueRenderer = (selected) => {
    if (!selected.length) {
      return <Clock />;
    } else if (selected.length === 1) {
      return selected[0].label;
    } else {
      return `${selected.length} schedules selected`;
    }
  };

  const handleClick = (e) => {
    setSelected(e);

    const array = [];

    e?.map(({ label, value }) => {
      return array.push({
        label: label,
        value: value,
      });
    });

    setSelected(array);

    handleOnSubmit(array);
  };

  const schedulesFilterOptions = (options, filter) => {
    if (!filter) {
      return options;
    }

    return options.filter(({ label }) => {
      return label && label?.toLowerCase().includes(filter);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    handleOnSubmit(e, selected);
    setOpen(false);
  };

  function setFilterHeight() {
    if (typeof window === "object") {
      return document.documentElement.style.setProperty(
        "--filter-height",
        `${ref.current?.offsetHeight}px`,
      );
    }
  }

  setFilterHeight();

  useEffect(() => {
    setFilterHeight();
  }, [open]);

  return (
    <div ref={ref}>
      {open && (
        <form
          className={styles.wrapper}
          method="GET"
          action="submit"
          onSubmit={handleSubmit}
        >
          <span className={styles.group}>
            <label htmlFor="schedules" className={styles.label}>
              Schedule Name
            </label>
            <MultiSelect
              className={classnames(styles.select, styles.select_middle)}
              options={scheduleOptions}
              value={selected}
              onChange={handleClick}
              valueRenderer={schedulesValueRenderer}
              filterOptions={schedulesFilterOptions}
            />
          </span>
        </form>
      )}

      <button
        className={classnames(styles.toogle, open ? styles.active : "")}
        onClick={() => setOpen(!open)}
      >
        {open ? "Hide Filters" : "Show Filters"}
      </button>
    </div>
  );
};

export default FilterForm;
